module.exports = __webpack_public_path__ + "img/gray-enabing-skills.c844fd20.png";